import { jsx as _jsx } from "react/jsx-runtime";
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { LoginForm } from "./components/LoginForm"; // ログインフォームの表示部分を担当するコンポーネント（別ファイルに切り出し）
/*
* ログインのコンポーネント
* - validationSPA: 画面全体のロジックを管理するシングルページアプリケーションコンポーネント
* - LoginForm: ログインフォームの表示部分を担当するコンポーネント（別ファイルに切り出し）
*/
// validationSPA: 自治体過去閲覧履歴画面全体を表すシングルページアプリケーションコンポーネント
// 検索条件の入力、検索結果の表示、詳細表示への遷移など、画面全体のロジックを管理する。
// 検索結果の表示部分は、validationResultsTable関数を別ファイルに切り出している。
export const ValidationSPA = () => {
    // Reactで要素を操作したい場合は、state変数で管理するのが一般的。検索条件の状態管理（状態を管理する変数と、その値を更新する関数）
    const [user_id, setUser_id] = useState("");
    const [userpassword, setUserpassword] = useState("");
    const [results, setResults] = useState([]);
    const [error, setError] = useState("");
    const [errorMessages, setErrorMessages] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false); // 初期化が終わってから描画・自動送信する
    // data-auth-modeが「open」の場合は自動ログインモード、「manual」の場合は手動ログインモード
    const [isOpenModeState, setIsOpenModeState] = useState(false);
    const baseDir = useRef("");
    const getQueryParam = (key) => {
        const params = new URLSearchParams(window.location.search);
        return params.get(key);
    };
    // 初期表示時にクエリパラメータを反映
    useEffect(() => {
        const rootElement = document.getElementById("root");
        // data-auth-modeが「manual」の場合は手動ログインモード、「open」の場合は自動ログインモード
        const authMode = (rootElement?.getAttribute("data-auth-mode") || "manual").toLowerCase();
        // data-auto-login-userとdata-auto-login-passwordが設定されている場合は自動ログイン用のID/PASSを取得
        const autoLoginUser = rootElement?.getAttribute("data-auto-login-user") || "";
        const autoLoginPassword = rootElement?.getAttribute("data-auto-login-password") || "";
        const isOpenMode = authMode === "open";
        // isOpenModeをstateに保持
        setIsOpenModeState(isOpenMode);
        // 固定のユーザー名とパスワードを設定（デバッグ用）
        if (isOpenMode) {
            setUser_id(autoLoginUser);
            setUserpassword(autoLoginPassword);
        }
        // login_failed=1のときはクエリパラメータから検索条件をセットして自動検索する
        if (getQueryParam("login_failed") === "1") {
            setErrorMessages(["ユーザー名またはパスワードが正しくありません。"]);
            setIsInitialized(true); // エラーメッセージがある場合はここで初期化完了
        }
        else if (getQueryParam("session_expired") === "1" && !isOpenModeState) {
            setErrorMessages(["セッションが切れました。再度ログインしてください。"]);
            setIsInitialized(true); // エラーメッセージがある場合はここで初期化完了
        }
        else {
            // 通常時：初期化完了
            setIsInitialized(true);
        }
        baseDir.current = window.location.pathname.split('/').filter(Boolean)[0] || 'dummy_path_aaaaaaaaaa';
    }, []);
    // ユーザー名とパスワードが設定された後に自動ログイン処理を実行
    useEffect(() => {
        if (user_id !== "" && userpassword !== "" && isInitialized && isOpenModeState) {
            handleLoginClick({ preventDefault: () => { } });
        }
    }, [user_id, userpassword, isInitialized, isOpenModeState]);
    //************************************************
    //   イベント
    //************************************************
    function validateSurvey(data) {
        let errors = {};
        if (!data.user_id || data.user_id.trim() === "") {
            errors.user_id = "ユーザー名は必須です。";
        }
        if (!data.userpassword || data.userpassword.trim() === "") {
            errors.userpassword = "パスワードは必須です。";
        }
        // if (!data.age || isNaN(data.age) || parseInt(data.age) < 1) {
        //     errors.age = "年齢は正の整数で入力してください。";
        // }
        return errors;
    }
    // 「ログイン」ボタンのクリックイベント
    const handleLoginClick = async (e) => {
        e.preventDefault(); // フォーム送信を防ぐ
        const user_idInput = user_id;
        const userpasswordInput = userpassword;
        // バリデーションを実行
        let errors = validateSurvey({
            user_id: user_idInput,
            userpassword: userpasswordInput
        });
        // エラーメッセージを表示
        setErrorMessages([]);
        if (Object.keys(errors).length > 0) {
            setErrorMessages(Object.values(errors));
            return;
        }
        // 必須エラーがない場合はフォームを送信
        (async () => {
            const apiUrl = `/${baseDir.current}/public/login`;
            try {
                // ログイン処理なので、POSTメソッドを使用してユーザー名とパスワードを送信する
                const res = await axios.post(apiUrl, {
                    user_id: user_idInput,
                    userpassword: userpasswordInput
                });
                let data = res.data;
                // alert(data.status);
                if (data.status === "success") {
                    // ログイン成功時の処理
                    location.href = `/${baseDir.current}/public/`;
                }
                else {
                    setErrorMessages([data.message]);
                }
            }
            catch (err) {
                const apiMessage = err?.response?.data?.message;
                setErrorMessages([apiMessage || "ログイン処理に失敗しました。時間をおいて再度お試しください。"]);
            }
        })();
    };
    // 「アカウント登録」ボタンのクリックイベント
    const GoRegister = useCallback(() => {
        let redirect_url = "invite/create";
        location.href = redirect_url;
    }, []);
    return (_jsx("div", { children: _jsx("div", { style: {
                opacity: isInitialized ? 1 : 0,
                transition: 'opacity 0.3s ease-in-out'
            }, children: isInitialized && (_jsx(LoginForm, { user_id: user_id, userpassword: userpassword, errorMessages: errorMessages, onUser_idChange: setUser_id, onUserPasswordChange: setUserpassword, onLoginClick: handleLoginClick, onRegisterClick: GoRegister, baseDir_current: baseDir.current })) }) }));
};
export default ValidationSPA;
